import React from 'react';
import classnames from 'classnames';

const Select = (props) => {
  const {
    onKeyDown,
    stateType,
    updateHandler,
    id,
    attr,
    options,
    value,
    addon,
    className,
    smBlockClass,
    blockClass,
    validationResult,
  } = props;

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      onKeyDown(e);
    }
  };

  const handleChange = (e) => {
    if (stateType) {
      updateHandler(e.target.value, stateType);
    } else {
      updateHandler(e.target.value);
    }
  };

  const optionsPart = options.map((opt) => (
    <option key={`${id}-${opt.name}`} value={opt.value}>
      {opt.name}
    </option>
  ));
  let combinedClassName;
  if (validationResult && !validationResult.success) {
    combinedClassName = classnames(className, 'invalid');
  }
  let wrapperClass = 'select';
  if (smBlockClass) {
    wrapperClass = 'select sm-select-block';
  } else if (blockClass) {
    wrapperClass = 'select select-block';
  }
  return (
    <div className={wrapperClass}>
      {addon}
      <select
        {...attr}
        id={id}
        className={combinedClassName}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      >
        {optionsPart}
      </select>
    </div>
  );
};

export default Select;
